const dataDefault = [{
    name: "Hotel Name 酒店名称:",
    value: "",
    tel: "",
    email: "",
}, {
    tel: "",
    email: "",
    name: "Brand Tier 品牌体系:",
    value: ""
}, {
    name: "Site Number 酒店编号:",
    tel: "",
    email: "",
    value: ""
}, {
    name: "Available Rooms 客房数:",
    tel: "",
    email: "",
    value: ""
}, {
    name: "Date of Open 开业日期: ",
    tel: "",
    email: "",
    value: ""
}, {
    name: "GM/HM 总经理/酒店经理: ",
    tel: "",
    email: "",
    value: ""
}, {
    name: "RM/EAM 驻店经理/行政助理经理: ",
    tel: "",
    email: "",
    value: ""
}, {
    name: "DOF/FM 财务总监/财务经理: ",
    tel: "",
    email: "",
    value: ""
}, {
    name: "DHR 人力资源总监: ",
    tel: "",
    email: "",
    value: ""
}, {
    name: "DOSM 市场营销总监: ",
    tel: "",
    email: "",
    value: ""
}, {
    name: "DFB 餐饮总监: ",
    tel: "",
    email: "",
    value: ""
}, {
    name: "DOC 宴会统筹总监: ",
    tel: "",
    email: "",
    value: ""
}, {
    name: "DOR 房务总监/EHK 行政管家: ",
    tel: "",
    email: "",
    value: ""
}, {
    name: "FOM 前厅经理: ",
    tel: "",
    email: "",
    value: ""
}, {
    name: "DOE 工程总监:",
    tel: "",
    email: "",
    value: ""
}, {
    name: "REVM 收益经理: ",
    tel: "",
    email: "",
    value: ""
}]


export default dataDefault; 


// WEBPACK FOOTER //
// ./src/components/table/cover/data.js